// OPERATIONAL STATUSES: 1 - nothing affected (green), 2 - some affected, 3 - all affected
export const systems = [
    {
        name: "Ad Delivery",
        operationalStatus: 1,
    },
    {
        name: "Cloud Login",
        operationalStatus: 1,
    },
    {
        name: "Cloud Reports",
        operationalStatus: 1,
    },
    {
        name: "Cloud Data API",
        operationalStatus: 1,
    },
    {
        name: "Flow Analytics",
        operationalStatus: 1,
    }
];

export const incidents = [
    // IMPORTANT NOTE: ADD LATEST ACTION AS A FIRST ELEMENT IN INCIDENTS ARRAY
    // TEMPLATE PLEASE DO NOT REMOVE
    // {
    //     title: "Incident",
    //     fire: 1, // 1, 2 or 3 fire icons
    //     date: Date.UTC("2021", "05", "10", "15", "00"), // UTC time (year, month (!! months are counted from 0 !!), day, hour, minutes)
    //     description: "Description",
    //     isFixed: false, // change to true after fixing (true move incident into past incidents section)
    //     IMPORTANT NOTE: ADD LATEST ACTION AS A LAST ELEMENT IN ACTIONS ARRAY
    //     actions: [
    //     NOTE: Last incident counter is based on last action time - last incident counter = 0 if incident is not fixed
    //       {
    //           status: "Status e.g. Monitoring",
    //           description: "Some description of current state",
    //           time: Date.UTC("2021", "04", "10", "15", "30"), // UTC time (year, month (!! months are counted from 0 !!), day, hour, minutes)
    //       },
    //     ]
    // },
    {
        title: "Incident",
        fire: 1,
        date: Date.UTC("2021", "11", "08", "12", "00"),
        description: "Some users have reported issues with slow Cloud reports. The case is being investigated.",
        isFixed: true,
        actions: [
            {
                status: "Work in progress",
                description: "The case is being investigated.",
                time: Date.UTC("2021", "11", "08", "12", "00"),
            },
            {
                status: "Work in progress",
                description: "Currently removing redundant data views and extending data (pre-)caching.",
                time: Date.UTC("2021", "11", "09", "13", "30"),
            },
            {
                status: "Work in progress",
                description: "New data pre-caching is beeing deployed. There might be issues loading data currently",
                time: Date.UTC("2021", "11", "14", "20", "45"),
            },
            {
                status: "Work in progress",
                description: "New data caching is deployed, keeping close eye on it",
                time: Date.UTC("2021", "11", "14", "23", "25"),
            },
            {
                status: "Monitoring",
                description: "Made some more improvements to reduce overall system load. Keeping close eye on analytical data loading",
                time: Date.UTC("2021", "11", "16", "21", "43"),
            },
            {
                status: "Resolved",
                description: "The issue is resolved.",
                time: Date.UTC("2022", "00", "10", "15", "45"),
            },
        ],
    },
    {
        title: "Incident",
        fire: 1,
        date: Date.UTC("2021", "11", "06", "15", "00"),
        description: "Data aggregation hiccups on November 28th between 1am-2am",
        isFixed: true,
        actions: [
            {
                status: "Restoration in process",
                description: "The affected time period has been identified and we are restoring aggregate data from raw data",
                time: Date.UTC("2021", "10", "30", "11", "00"),
            },
            {
                status: "Data restored",
                description: "Data restoration has completed",
                time: Date.UTC("2021", "11", "06", "15", "00"),
            },            
        ],
    },
    {
        title: "Incident",
        fire: 1,
        date: Date.UTC("2021", "09", "23", "8", "00"),
        description: "We have found some data inconsistency issues between standard and flow reports",
        isFixed: true,
        actions: [
            {
                status: "Work in progress",
                description: "The case is being investigated.",
                time: Date.UTC("2021", "09", "23", "8", "00"),
            },
            {
                status: "Restoration in process",
                description: "The affected dates have been identified as October 13th, 17th and 18th. We are restoring data from raw data",
                time: Date.UTC("2021", "09", "25", "07", "30"),
            },
            {
                status: "Data restored",
                description: "Data restoration has finished. We are continuing our validation",
                time: Date.UTC("2021", "09", "26", "09", "00"),
            },
            {
                status: "Data validation",
                description: "We are extending our validation efforts",
                time: Date.UTC("2021", "09", "27", "07", "00"),
            },
            {
                status: "Data anomaly detection",
                description: "Continuing on on-going work with data anomaly detection, while further extending validation efforts.",
                time: Date.UTC("2021", "09", "28", "07", "00"),
            },
            {
                status: "Data validation",
                description: "Sifting through raw data takes time. Slow and steady progress with validation efforts",
                time: Date.UTC("2021", "10", "01", "07", "00"),
            },
            {
                status: "Resolved",
                description: "Data has been restored and work has been started to have better visibility and data quality checks",
                time: Date.UTC("2021", "10", "02", "10", "30"),
            },
        ],
    },
    {
        title: "Incident",
        fire: 2, // 1, 2 or 3 fire icons
        date: Date.UTC("2021", "08", "07", "08", "43"), // UTC time (year, month (!! months are counted from 0 !!), day, hour, minutes)
        description: "Some data from 26th of August is not showing up in reports",
        isFixed: true, // change to true after fixing (true move incident into past incidents section)
        actions: [
            {
                status: "Investigating",
                description: "We have no loss of data. There's 3h time window in 26th of August where only half of data is visible. Investigation continues",
                time: Date.UTC("2021", "08", "07", "10", "38"),
            },
            {
                status: "Preparing to restore",
                description: "We are preparing to restore visible analytics data from raw data for given day",
                time: Date.UTC("2021", "08", "07", "12", "46"),
            },
            {
                status: "Restoration in process",
                description: "We are restoring data from raw data",
                time: Date.UTC("2021", "08", "08", "13", "16"),
            },
            {
                status: "Data restored",
                description: "Data restoration has finished. We still need to ensure that new data is visible",
                time: Date.UTC("2021", "08", "10", "12", "29"),
            },
            {
                status: "Resolved",
                description: "Data has been restored and work has been started to have better visibility and data quality checks",
                time: Date.UTC("2021", "08", "14", "11", "26"),
            },
        ]
    },
    {
        title: "Incident",
        fire: 1,
        date: Date.UTC("2021", "06", "08", "7", "45"),
        description: "Some users have reported issues with Cloud access and login page. The case is being investigated.",
        isFixed: true,
        actions: [
            {
                status: "Work in progress",
                description: "The case is being investigated.",
                time: Date.UTC("2021", "06", "08", "7", "45"),
            },
            {
                status: "Resolved",
                description: "The issue is resolved.",
                time: Date.UTC("2021", "06", "08", "10", "00"),
            },            
            
        ],
    },

    {
        title: "Incident",
        fire: 2,
        date: Date.UTC("2021", "05", "29", "11", "30"),
        description: "Some users have reported issues with Cavai Cloud and we're seeing a spike in network traffic",
        isFixed: true,
        actions: [
            {
                status: "Work in progress",
                description: "The issue is being investigated.",
                time: Date.UTC("2021", "05", "29", "9", "30"),
            },
            {
                status: "Unresolved",
                description: "Traffic spikes made Cavai Cloud temporarily unavailable by overwhelming it with traffic from multiple sources and regions. No further actions will be taken at this time.",
                time: Date.UTC("2021", "05", "29", "13", "00"),
            },
        ],
    },
    
    {
        title: "Incident",
        fire: 1,
        date: Date.UTC("2021", "05", "21", "9", "30"),
        description: "Some users have reported issues with login page not detecting saved email. The case is being investigated.",
        isFixed: true,
        actions: [
            {
                status: "Work in progress",
                description: "The case is being investigated.",
                time: Date.UTC("2021", "05", "21", "9", "30"),
            },
            {
                status: "Work in progress",
                description: "Testing new patch in different browsers and extensions.",
                time: Date.UTC("2021", "05", "22", "6", "30"),
            },
            {
                status: "Resolved",
                description: "The issue should be resolved for most commonly used browsers.",
                time: Date.UTC("2021", "05", "22", "08", "30"),
            },            
        ],
    },
    
    {
        title: "Incident",
        fire: 1,
        date: Date.UTC("2021", "04", "31", "11", "30"),
        description: "Some display ads are not shown correctly on one publisher page. The case is being investigated.",
        isFixed: true,
        actions: [
            {
                status: "Work in progress",
                description: "The affected creatives are being investigated.",
                time: Date.UTC("2021", "04", "31", "11", "30"),
            },
            {
                status: "Resolved",
                description: "The specific publisher page's global style no longer affect creatives.",
                time: Date.UTC("2021", "04", "31", "13", "52"),
            },
        ],
    },
    
    {
        title: "Incident",
        fire: 2,
        date: Date.UTC("2021", "04", "13", "18", "13"),
        description: "It appears that flow reports for selected creatives are affected by an issue leading to data not being displayed correctly for the affected creatives. The case is being investigated.",
        isFixed: true,
        actions: [
            {
                status: "Work in progress",
                description: "The likely cause have been identified, and a fix is being implemented.",
                time: Date.UTC("2021", "04", "13", "17", "02"),
            },
            {
                status: "Resolved",
                description: "As part of previous incident fix accidentally only half of the flow data was made visible in reports. Fix has been deployed and now all the data is visible in flow reports again",
                time: Date.UTC("2021", "04", "13", "20", "41"),
            },
        ],
    },


    {
        title: "Incident",
        fire: 2,
        date: Date.UTC("2021", "04", "10", "13", "00"),
        description: "Primary flow analytics data processing had hiccups, which made flow data to not appear in reporting. There was no loss of data and reporting data is being recovered from a secondary system.",
        isFixed: true,
        actions: [
            {
                status: "Work in progress",
                description: "Data recovery is still in progress. Stay tuned for further updates.",
                time: Date.UTC("2021", "04", "10", "19", "12"),
            },
            {
                status: "Work in progress",
                description: "Data restoration is completed, but data for some creatives is not yet visible in flow reports.",
                time: Date.UTC("2021", "04", "11", "08", "51"),
            },
            {
                status: "Fixed",
                description: "Everything is back to normal. Data is restored and visible in flow reports.",
                time: Date.UTC("2021", "04", "11", "14", "35"),
            },
        ],
    },
];
